const constant = {
  BASE_URL: process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8001/api/",
  GOOGLE_MAPS_KEY: process.env.VUE_APP_GOOGLE_MAPS_KEY,
};
module.exports = {
  ...constant,
};
